import { useCallback, useMemo } from "react";
import Icon from "../../../controls/Icon";

const HeaderTabs = ({
    listData,
    listAttr = "name",
    listOnClick,
    selectedTab = "",
    disabled,
    errors = {}
}) => {
    const handleClick = useCallback((event, dataElement, value) => {
        if (!disabled) {
            event.preventDefault();
            listOnClick(dataElement, value);
        }
    }, [listOnClick, disabled]);

    const listItems = useMemo(() => listData.map((element, index) => {
        return (
            <button
                id={element.id}
                key={index}
                className={`list-group-item small list-group-item-action text-center text-lg-start text-nowrap d-flex align-items-center  ${selectedTab === element._id ? "active" : ""}`}
                data-element={element._id}
                onClick={(event) => handleClick(event, element._id, element[listAttr])}>
                <span>{element[listAttr]}</span>
                {errors?.[element._id] ? <Icon icon="ErrorOutline" className={`ms-1 fs-5 ${selectedTab === element._id ? "" : "text-danger"}`} /> : null}
            </button>
        )
    }), [listData, listAttr, selectedTab, handleClick, errors]);

    return (
        listData && <div className="col-12 col-lg-auto mt-2">
            <div className={`list-group list-group-horizontal-lg`}>
                {listItems}
            </div>
        </div>
    );
}

export default HeaderTabs;